














































































































import { Component, Vue } from 'vue-property-decorator'
import Slider from '../ui/Slider.vue'

@Component({
  components: {
    Slider
  }
})
export default class TabThickness extends Vue {
  private strength = [0, 1, 2, 3]
  private strengthValues = ['1.50', '1.60', '1.67', '1.74']
  private thickness = ['-10', '-9', '-8', '-7', '-6', '-5', '-4', '-3', '-2', '-1', '0', '+1', '+2', '+3', '+4', '+5', '+6', '+7', '+8']
  private thicknessImageBefore = ['150', '160', '167', '174']
  private thicknessImageAfter = ['-minus-10.png', '-minus-09.png', '-minus-08.png', '-minus-07.png', '-minus-06.png', '-minus-05.png', '-minus-04.png', '-minus-03.png', '-minus-02.png', '-minus-01.png', '-plus-00.png', '-plus-01.png', '-plus-02.png', '-plus-03.png', '-plus-04.png', '-plus-05.png', '-plus-06.png', '-plus-07.png', '-plus-08.png']

  private leftStrength: number = 0
  private rightStrength: number = 0
  private leftIndex: number = 0
  private rightIndex: number = 0

  private leftStrengthValue: string = '0'
  private rightStrengthValue: string = '0'
  private leftIndexValue: string = '0'
  private rightIndexValue: string = '0'

  private leftImage: string = require('@/assets/images/tabs/thickness/lenses-flipped/lens-150-minus-01.png')
  private rightImage: string = require('@/assets/images/tabs/thickness/lenses/lens-150-minus-01.png')

  public onInputLeftStrength (input: number) {
    this.leftStrength = input
    this.leftStrengthValue = this.thickness[input]
    this.updateLeft()
  }

  public onInputRightStrength (input: number) {
    this.rightStrength = input
    this.rightStrengthValue = this.thickness[input]
    this.updateRight()
  }

  public onInputLeftIndex (input: number) {
    this.leftIndex = input
    this.leftIndexValue = this.strengthValues[input]
    this.updateLeft()
  }

  public onInputRightIndex (input: number) {
    this.rightIndex = input
    this.rightIndexValue = this.strengthValues[input]
    this.updateRight()
  }

  private updateRight () {
    this.rightImage =
      require('@/assets/images/tabs/thickness/lenses/lens-' +
        this.thicknessImageBefore[this.rightIndex] + this.thicknessImageAfter[this.rightStrength])
  }

  private updateLeft () {
    this.leftImage =
      require('@/assets/images/tabs/thickness/lenses-flipped/lens-' +
        this.thicknessImageBefore[this.leftIndex] + this.thicknessImageAfter[this.leftStrength])
  }

  private mounted () {
    this.updateLeft()
    this.updateRight()
  }
}
